import { Modal } from 'components/content';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';
import { CollectionsFetchStatus } from 'stores/OrderPadSales';
import { RepCollectionsPeriod } from './RepCollectionsPeriod';
import {
  LoadingSpinner,
  SavingIndicator,
  SavingIndicatorStatus,
} from 'components/indicator';

const s = require('./RepCollectionsModal.css');

// Props
interface IRepCollectionsModalProps extends IAppOnlyStore {
  show: boolean;
}

// Component
@inject('store')
@observer
export class RepCollectionsModal extends React.Component<
  IRepCollectionsModalProps,
  {}
> {
  static get defaultProps(): IRepCollectionsModalProps {
    return {
      show: false,
    };
  }

  @computed
  private get isLoading(): boolean {
    return (
      this.props.store.orderPadSales.collectionsMonthsFetchStatus ===
        CollectionsFetchStatus.Loading &&
      this.props.store.orderPadSales.collectionsMonthsData.length <= 0
    );
  }

  public componentDidMount() {
    if (this.props.show) {
      this.props.store.orderPadSales.fetchMonthlyCollections();
    }
  }

  public componentWillReceiveProps(nextProps: IRepCollectionsModalProps) {
    if (this.props.show !== nextProps.show && nextProps.show) {
      this.props.store.orderPadSales.fetchMonthlyCollections();
    }
  }

  public render() {
    const { orderPadSales } = this.props.store;

    return (
      <Modal
        onModalClose={this.closeModal}
        show={this.props.show}
        title="Monthly collections"
      >
        {this.props.show && (
          <div className={s.container}>
            {(this.isLoading && (
              <div className={s.loading}>
                <LoadingSpinner active={true} />
              </div>
            )) || (
              <div className={s.content}>
                <div className={s.status}>
                  <SavingIndicator
                    align="center"
                    labels={{
                      saving: 'Updating data',
                      error: 'Could not fetch data. ',
                      retry: 'Click here to try again',
                    }}
                    onRetry={this.retryMonthlyCollectionsFetch}
                    status={
                      orderPadSales.collectionsMonthsFetchStatus ===
                      CollectionsFetchStatus.Loading
                        ? SavingIndicatorStatus.Saving
                        : orderPadSales.collectionsMonthsFetchStatus ===
                          CollectionsFetchStatus.Error
                        ? SavingIndicatorStatus.Error
                        : SavingIndicatorStatus.None
                    }
                  />
                </div>

                {(orderPadSales.collectionsMonthsData.length && (
                  <div className={s.table}>
                    {orderPadSales.collectionsMonthsData.map((period) => (
                      <RepCollectionsPeriod key={period.key} period={period} />
                    ))}
                  </div>
                )) || (
                  <div className={s.table}>
                    <div className={s.empty}>
                      <p>No sales data available.</p>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </Modal>
    );
  }

  private closeModal = () => {
    this.props.store.orderPadSales.toggleCollectionsModal(false);
  };

  private retryMonthlyCollectionsFetch = () => {
    this.props.store.orderPadSales.fetchMonthlyCollections();
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Sales/RepCollectionsModal.tsx